export enum PaymentMethod {
    BankTransfer = 'BankTransfer',
    CreditCard = 'CreditCard',
    Cash = 'Cash',
    OnlinePayment = 'OnlinePayment',
    Other = 'Other'
}

export const PaymentMethodTranslations: Record<PaymentMethod, string> = {
    [PaymentMethod.BankTransfer]: 'تحويل بنكي',
    [PaymentMethod.CreditCard]: 'بطاقة ائتمان',
    [PaymentMethod.Cash]: 'نقداً',
    [PaymentMethod.OnlinePayment]: 'دفع إلكتروني',
    [PaymentMethod.Other]: 'أخرى',
};

export const PaymentMethodOptions = Object.values(PaymentMethod).map((method) => ({
    value: method,
    label: method,
    labelAr: PaymentMethodTranslations[method],
}));